<template>
    <PackageDetails/>
</template>

<script>
import PackageDetails from '../../components/packages/PackageDetails';

export default {
  components: {
    PackageDetails,
  },
};
</script>
